/**
 * Shared access to the worker's persisted Advanced Shift Search filters.
 *
 * The filters are written by SearchShiftPage and read back by any flow that has to
 * honour them after the search itself — currently Apply Shift, which must send the
 * same "Ignore My Unavailable Days" override the search used.
 */
export const ADVANCED_FILTERS_STORAGE_KEY = "searchShiftAdvancedFilters";

/**
 * Reads a single persisted advanced filter value, falling back to the supplied
 * default when nothing is stored or the stored payload cannot be parsed.
 */
export const getStoredAdvancedFilter = (key: string, defaultValue: any) => {
  try {
    const stored = localStorage.getItem(ADVANCED_FILTERS_STORAGE_KEY);
    if (stored) {
      const data = JSON.parse(stored);
      return data[key] !== undefined ? data[key] : defaultValue;
    }
  } catch (err) {
    console.error("Error loading filter from localStorage:", err);
  }
  return defaultValue;
};

/**
 * True when the worker enabled "Ignore My Unavailable Days" in Advanced Search.
 * Used to keep Apply Shift consistent with the results the search returned.
 */
export const getIgnoreWorkerUnavailability = (): boolean =>
  getStoredAdvancedFilter("ignoreWorkerUnavailability", false) === true;
